import ConfirmationModal from 'components/common/ConfirmationMessage';
import EditDayOffModal from 'components/appointment/EditDayOffModal';
import EditLunchModal from 'components/appointment/EditLunchModal';
import EditTravelTimeModal from 'components/appointment/EditTravelTimeModal';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import moment from 'moment';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { InterpreterDashboardSelector } from 'slices/interpreter/dashboardSlice';
import { fetchInterpreterDashboardAppointments, interpreterDeleteDayOff, interpreterEditLunch, interpreterDeleteLunch, interpreterDeleteTravelTime } from 'slices/interpreter/dashboardSlice';
import { adminDeleteDayOff, adminEditLunch, adminDeleteLunch, adminDeleteTravelTime } from 'slices/dashboardSlice';
import { userSelector } from 'slices/userSlice';

const BASE_PARAMS = { type: [0, 1, 4, 5], pageLength: 100, sortBy: 'date', sortDirection: 'desc' };

const LUNCH_STYLE = { background: '#2e7d3222' };
const LUNCH_EYE_STYLE = { background: '#2e7d32' };
const DAY_OFF_STYLE = { background: '#fd7e1433' };
const DAY_OFF_EYE_STYLE = { background: '#fd7e14' };
const TRAVEL_TIME_STYLE = { background: '#ff69b433' };
const TRAVEL_TIME_EYE_STYLE = { background: '#e91e8c' };

const getDuration = (start_time, end_time) => {
    if (!start_time || !end_time) return null;
    const mins = moment(end_time, 'HH:mm:ss').diff(moment(start_time, 'HH:mm:ss'), 'minutes');
    if (mins <= 0) return null;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (h === 0) return `${m} min`;
    if (m === 0) return `${h} hr`;
    return `${h} hr ${m} min`;
};

const ListTable = ({ data, lunchRecords = [], showLunch = true, filtration, hidePagination = false, hideHeader = false, heading, link, showInterpreter = false, isAdmin = false, onRefresh }) => {
    const dispatch = useDispatch();
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);
    const [editDayOff, setEditDayOff] = React.useState({ show: false, item: null });
    const [deleteDayOffModal, setDeleteDayOffModal] = React.useState({ show: false, item: null });
    const [editLunchModal, setEditLunchModal] = React.useState({ show: false, item: null });
    const [deleteLunchModal, setDeleteLunchModal] = React.useState({ show: false, item: null });
    const [editTravelTimeModal, setEditTravelTimeModal] = React.useState({ show: false, item: null });
    const [deleteTravelTimeModal, setDeleteTravelTimeModal] = React.useState({ show: false, item: null });

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'date',
        sortDirection: 'asc',
    });
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { last_page: totalPages, current_page, per_page: pageLength, total } = useSelector(InterpreterDashboardSelector);
    const { user: currentUser } = useSelector(userSelector);

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };
    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }
    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }
    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    //#region TABLE HEAD
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir });
            dispatch(fetchInterpreterDashboardAppointments(currentPage, {
                ...BASE_PARAMS,
                ...filtration,
                sortBy,
                sortDirection: dir,
                search: searchTerm,
            }));
        }

        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="Timestamp"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        activeSortBy={sortConfig.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Job No.#"
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        activeSortBy={sortConfig.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>Person Completing the Form</th>
                <th>Site/Department/ Location</th>
                <th>Format for Meeting</th>
                <th>Type of Meeting</th>
                <th>Meeting Date</th>
                <th>Meeting Start Time</th>
                <th>Meeting End Time</th>
                <th>Meeting Location</th>
                <th>Interpreter should report to whom?</th>
                <th>Name of the assigned interpreter</th>
                <th>Student's Name</th>
                <th>School Student Currently Attends</th>
                <th>Parent or Guardian's Name</th>
                <th>Parent or Guardian's Phone Number</th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language"
                        sortDirection={sortConfig.sortDirection}
                        activeSortBy={sortConfig.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        activeSortBy={sortConfig.sortBy}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems, filtration]);
    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        setActionAccept({
            show: true,
            item: { id },
        });
    }, [])

    const handleCloseActionButton = React.useCallback((id) => {
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])

    const handleDeclineShow = React.useCallback((id) => {
        setDeclineModal({
            show: true,
            item: { id },
        });
    }, [])

    const handleEditDayOff = React.useCallback((item) => {
        setEditDayOff({ show: true, item });
    }, []);

    const handleDeleteDayOff = React.useCallback((item) => {
        setDeleteDayOffModal({ show: true, item });
    }, []);

    const handleEditLunch = React.useCallback((lunch) => {
        setEditLunchModal({ show: true, item: lunch });
    }, []);

    const handleDeleteLunch = React.useCallback((lunch) => {
        setDeleteLunchModal({ show: true, item: lunch });
    }, []);

    const handleEditTravelTime = React.useCallback((item) => {
        setEditTravelTimeModal({ show: true, item });
    }, []);

    const handleDeleteTravelTime = React.useCallback((item) => {
        setDeleteTravelTimeModal({ show: true, item });
    }, []);

    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            <>
                {data?.map((item, index) => (
                    // eslint-disable-next-line eqeqeq
                    item?.type == 4
                        ? <DayOffRow key={item?.id} item={item} showInterpreter={showInterpreter} onEdit={handleEditDayOff} onDelete={handleDeleteDayOff} canManage={isAdmin || (item?.interpreter?.user_id != null && currentUser?.user?.id != null && item.interpreter.user_id === currentUser.user.id)} />
                        // eslint-disable-next-line eqeqeq
                        : item?.type == 5
                            ? <TravelTimeRow key={item?.id} item={item} showInterpreter={showInterpreter} onEdit={handleEditTravelTime} onDelete={handleDeleteTravelTime} canManage={isAdmin || (item?.interpreter?.user_id != null && currentUser?.user?.id != null && item.interpreter.user_id === currentUser.user.id)} />
                            : <AppointmentListItem key={item?.id} item={item} index={index} link={link} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} showInterpreter={showInterpreter} />
                ))}
                {showLunch && lunchRecords?.map((lunch) => (
                    <LunchRow
                        key={lunch?.id}
                        lunch={lunch}
                        showInterpreter={showInterpreter}
                        onEdit={handleEditLunch}
                        onDelete={handleDeleteLunch}
                        canManage={isAdmin || (lunch?.interpreter_user_id != null && currentUser?.user?.id != null && lunch.interpreter_user_id === currentUser.user.id)}
                    />
                ))}
            </>
        )
    }, [selectedItems, data, lunchRecords, showLunch, handleEditDayOff, handleDeleteDayOff, handleEditLunch, handleDeleteLunch, handleEditTravelTime, handleDeleteTravelTime, isAdmin, currentUser?.user?.id]);

    //#endregion

    const refreshList = React.useCallback(() => {
        dispatch(fetchInterpreterDashboardAppointments(1, { ...BASE_PARAMS, ...filtration }));
        if (onRefresh) onRefresh();
    }, [filtration, onRefresh]);

    const handleConfirmDeleteDayOff = () => {
        const { item } = deleteDayOffModal;
        const action = isAdmin
            ? adminDeleteDayOff(item.id, (success, message) => {
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    setDeleteDayOffModal({ show: false, item: null });
                    refreshList();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            })
            : interpreterDeleteDayOff(item.id, (success, message) => {
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    setDeleteDayOffModal({ show: false, item: null });
                    refreshList();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            });
        dispatch(action);
    };

    const handleConfirmDeleteLunch = () => {
        const numericId = String(deleteLunchModal.item.id).replace('lunch_', '');
        const action = isAdmin
            ? adminDeleteLunch(numericId, (success, message) => {
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    setDeleteLunchModal({ show: false, item: null });
                    refreshList();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            })
            : interpreterDeleteLunch(numericId, (success, message) => {
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    setDeleteLunchModal({ show: false, item: null });
                    refreshList();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            });
        dispatch(action);
    };

    const handleConfirmDeleteTravelTime = () => {
        const { item } = deleteTravelTimeModal;
        const action = isAdmin
            ? adminDeleteTravelTime(item.id, (success, message) => {
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    setDeleteTravelTimeModal({ show: false, item: null });
                    refreshList();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            })
            : interpreterDeleteTravelTime(item.id, (success, message) => {
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    setDeleteTravelTimeModal({ show: false, item: null });
                    refreshList();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            });
        dispatch(action);
    };

    return (
        <div className='mt-4'>
            <ListLayout
                heading={heading}
                key={JSON.stringify(filtration)}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchInterpreterDashboardAppointments}
                filtration={filtration}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                noOfItems={total}
                sortConfig={sortConfig}
                hidePagination={hidePagination}
                hideHeader={hideHeader}
            >
                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}
                {deleteDayOffModal.show && <ConfirmationModal onClose={() => setDeleteDayOffModal({ show: false, item: null })} isOpen={deleteDayOffModal.show} onConfirm={handleConfirmDeleteDayOff} confirmationText="Are you sure you want to delete this day off?" />}
                {deleteLunchModal.show && <ConfirmationModal onClose={() => setDeleteLunchModal({ show: false, item: null })} isOpen={deleteLunchModal.show} onConfirm={handleConfirmDeleteLunch} confirmationText="Are you sure you want to delete this lunch record?" />}
                {deleteTravelTimeModal.show && <ConfirmationModal onClose={() => setDeleteTravelTimeModal({ show: false, item: null })} isOpen={deleteTravelTimeModal.show} onConfirm={handleConfirmDeleteTravelTime} confirmationText="Are you sure you want to delete this travel time?" />}
            </ListLayout>
            {editDayOff.show && (
                <EditDayOffModal
                    show={editDayOff.show}
                    item={editDayOff.item}
                    isAdmin={isAdmin}
                    onClose={() => setEditDayOff({ show: false, item: null })}
                    onSuccess={() => { setEditDayOff({ show: false, item: null }); refreshList(); }}
                />
            )}
            {editLunchModal.show && (
                <EditLunchModal
                    show={editLunchModal.show}
                    item={editLunchModal.item}
                    isAdmin={isAdmin}
                    onClose={() => setEditLunchModal({ show: false, item: null })}
                    onSuccess={() => { setEditLunchModal({ show: false, item: null }); refreshList(); }}
                />
            )}
            {editTravelTimeModal.show && (
                <EditTravelTimeModal
                    show={editTravelTimeModal.show}
                    item={editTravelTimeModal.item}
                    isAdmin={isAdmin}
                    onClose={() => setEditTravelTimeModal({ show: false, item: null })}
                    onSuccess={() => { setEditTravelTimeModal({ show: false, item: null }); refreshList(); }}
                />
            )}
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, current_page, pageLength, link, showInterpreter
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    const getBackgroundStyle = (status) => {
        if (status === 'assigned') {
            return { background: '#785c9933' };
        } else if (status === 'open' || status === 'available') {
            return { background: '#ffb82a33' };
        } else if (status === 'dnc') {
            return { background: '#3176a033' };
        } else if (status === 'cnc') {
            return { background: '#9623e033' };
        } else if (status === 'completed') {
            return { background: '#1c2b2c33' };
        } else if (status === 'cancelled') {
            return { background: '#e33a3133' };
        } else if (status === 'vendor_declined') {
            return { background: '#ff000033' }
        } else if (status === 'declined') {
            return { background: '#ff000033' }
        } else if (status === 'pending') {
            return { background: '#3176a033' }
        } else if (status === 'day_off') {
            return DAY_OFF_STYLE;
        }
    };
    const getEyeStyle = (status) => {
        if (status === 'assigned') {
            return { background: '#785c99' };
        } else if (status === 'open' || status === 'available') {
            return { background: '#ffb82a' };
        } else if (status === 'dnc') {
            return { background: '#3176a0' };
        } else if (status === 'cnc') {
            return { background: '#9623e0' };
        } else if (status === 'completed') {
            return { background: '#1c2b2c' };
        } else if (status === 'cancelled') {
            return { background: '#e33a31' };
        } else if (status === 'vendor_declined') {
            return { background: '#b51a12' }
        } else if (status === 'declined') {
            return { background: '#b51a12' }
        } else if (status === 'pending') {
            return { background: '#3176a0' }
        } else if (status === 'day_off') {
            return DAY_OFF_EYE_STYLE;
        }
    };
    const displayStatus = item?.display_status ?? item?.status;

    const interpreterName = item?.vendor_id != null && item?.vendor_interpreter
        ? `${item.vendor_interpreter.first_name || ''} ${item.vendor_interpreter.last_name || ''} - Excel`.trim()
        : item?.vendor_id != null
            ? `${item?.vendor_user?.name || 'Vendor'} (Excel)`
            : item?.interpreter
                ? `${item.interpreter.first_name} ${item.interpreter.last_name}`
                : '—';

    return (
        <tr>
            <td className='p-0' style={getBackgroundStyle(displayStatus)}>
                <div className='eye_area' style={getEyeStyle(displayStatus)}>
                    <Link to={`/interpreter/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.created_at ? moment(item.created_at).format('MMM D, YYYY HH:mm') : '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                <Link className='link_preview' to={`/interpreter/appointments/view/${item?.id}`}>
                    {item?.appid || 'N/A'}
                </Link>
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.appointment_details?.contact_person_name || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.school?.name || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.meeting_format || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.appointment_details?.meeting_type || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.date ? moment(item.date).format('MMM D, YYYY') : '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.start_time ? moment(item.start_time, 'HH:mm:ss').format('h:mm A') : '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.end_time ? moment(item.end_time, 'HH:mm:ss').format('h:mm A') : '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.room_number_at_site || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.appointment_details?.reporting_person || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {interpreterName}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.appointment_details?.student_name || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.student_school?.name || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.appointment_details?.parent_name || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.appointment_details?.parent_contact_number || '—'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.language?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {displayStatus || 'N/A'}
            </td>
        </tr>
    )
})

const DayOffRow = ({ item, showInterpreter, onEdit, onDelete, canManage = false }) => {
    const dateLabel = item?.date
        ? moment(item.date, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'N/A';
    const timeLabel = item?.start_time && item?.end_time
        ? `${moment(item.start_time, 'HH:mm:ss').format('h:mm A')} – ${moment(item.end_time, 'HH:mm:ss').format('h:mm A')}`
        : item?.start_time
            ? moment(item.start_time, 'HH:mm:ss').format('h:mm A')
            : '—';
    const duration = getDuration(item?.start_time, item?.end_time);
    const interpreterName = item?.interpreter
        ? `${item.interpreter.first_name || ''} ${item.interpreter.last_name || ''}`.trim() || '—'
        : '—';

    return (
        <tr>
            <td className='p-0' style={DAY_OFF_STYLE}>
                <div className='eye_area' style={DAY_OFF_EYE_STYLE}>
                    <i className="fa-solid fa-ban"></i>
                </div>
            </td>
            <td style={DAY_OFF_STYLE}>{item?.created_at ? moment(item.created_at).format('MMM D, YYYY HH:mm') : '—'}</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>Day Off</td>
            <td style={DAY_OFF_STYLE}>{dateLabel}</td>
            <td style={DAY_OFF_STYLE}>{timeLabel}</td>
            <td style={DAY_OFF_STYLE}>{duration || '—'}</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>{interpreterName}</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>
                <div className="d-flex gap-2 justify-content-between align-items-center">
                    <span>Day Off</span>
                    {canManage && (
                        <div className="d-flex gap-2">
                            <button type="button" onClick={() => onEdit && onEdit(item)} style={{ background: 'none', border: 'none', color: '#555' }}><i className="fa-solid fa-pen-to-square"></i></button>
                            <button type="button" onClick={() => onDelete && onDelete(item)} style={{ background: 'none', border: 'none', color: '#c0392b' }}><i className="fa-solid fa-trash"></i></button>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    );
};

const TravelTimeRow = ({ item, showInterpreter, onEdit, onDelete, canManage = false }) => {
    const dateLabel = item?.date
        ? moment(item.date, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'N/A';
    const timeLabel = item?.start_time && item?.end_time
        ? `${moment(item.start_time, 'HH:mm:ss').format('h:mm A')} – ${moment(item.end_time, 'HH:mm:ss').format('h:mm A')}`
        : item?.start_time
            ? moment(item.start_time, 'HH:mm:ss').format('h:mm A')
            : '—';
    const duration = getDuration(item?.start_time, item?.end_time);
    const interpreterName = item?.interpreter
        ? `${item.interpreter.first_name || ''} ${item.interpreter.last_name || ''}`.trim() || '—'
        : '—';

    return (
        <tr>
            <td className='p-0' style={TRAVEL_TIME_STYLE}>
                <div className='eye_area' style={TRAVEL_TIME_EYE_STYLE}>
                    <i className="fa-solid fa-car"></i>
                </div>
            </td>
            <td style={TRAVEL_TIME_STYLE}>{item?.created_at ? moment(item.created_at).format('MMM D, YYYY HH:mm') : '—'}</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>Travel Time</td>
            <td style={TRAVEL_TIME_STYLE}>{dateLabel}</td>
            <td style={TRAVEL_TIME_STYLE}>{timeLabel}</td>
            <td style={TRAVEL_TIME_STYLE}>{duration || '—'}</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>{interpreterName}</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>—</td>
            <td style={TRAVEL_TIME_STYLE}>
                <div className="d-flex gap-2 justify-content-between align-items-center">
                    <span>Travel Time</span>
                    {canManage && (
                        <div className="d-flex gap-2">
                            <button type="button" onClick={() => onEdit && onEdit(item)} style={{ background: 'none', border: 'none', color: '#555' }}><i className="fa-solid fa-pen-to-square"></i></button>
                            <button type="button" onClick={() => onDelete && onDelete(item)} style={{ background: 'none', border: 'none', color: '#c0392b' }}><i className="fa-solid fa-trash"></i></button>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    );
};

const LunchRow = ({ lunch, showInterpreter, onEdit, onDelete, canManage = false }) => {
    const dateLabel = lunch?.date
        ? moment(lunch.date, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'N/A';
    const timeLabel = lunch?.start_time && lunch?.end_time
        ? `${moment(lunch.start_time, 'HH:mm').format('h:mm A')} – ${moment(lunch.end_time, 'HH:mm').format('h:mm A')}`
        : lunch?.start_time
            ? moment(lunch.start_time, 'HH:mm').format('h:mm A')
            : '—';
    const duration = getDuration(
        lunch?.start_time ? lunch.start_time + ':00' : null,
        lunch?.end_time ? lunch.end_time + ':00' : null
    );

    return (
        <tr>
            <td className='p-0' style={LUNCH_STYLE}>
                <div className='eye_area' style={LUNCH_EYE_STYLE}>
                    <i className="fa-solid fa-utensils"></i>
                </div>
            </td>
            <td style={LUNCH_STYLE}>{lunch?.created_at ? moment(lunch.created_at).format('MMM D, YYYY HH:mm') : '—'}</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>Lunch Break</td>
            <td style={LUNCH_STYLE}>{dateLabel}</td>
            <td style={LUNCH_STYLE}>{timeLabel}</td>
            <td style={LUNCH_STYLE}>{duration || '—'}</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>{lunch?.interpreter_name || '—'}</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>
                <div className="d-flex gap-2 justify-content-between align-items-center">
                    <span>On Lunch</span>
                    {canManage && (
                        <div className="d-flex gap-2">
                            <button type="button" onClick={() => onEdit && onEdit(lunch)} style={{ background: 'none', border: 'none', color: '#555' }}><i className="fa-solid fa-pen-to-square"></i></button>
                            <button type="button" onClick={() => onDelete && onDelete(lunch)} style={{ background: 'none', border: 'none', color: '#c0392b' }}><i className="fa-solid fa-trash"></i></button>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default ListTable
